import React from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga";
import Configuration, { translations } from "../config";
import { BrowserRouter, NavLink, Route, Switch } from "react-router-dom";
import { getConfigurations } from "../actions";
// Komponenten
import Messages from "../components/Messages";
import Access from "../components/Access";
// Hauptseiten
import NavHeader from "../containers/NavHeader";
import ReportsNavHeader from "../plugins/reports/containers/NavHeader";
import Questionnaires from "../plugins/questionnaires/containers/Questionnaires";
import QuestionnairesOverview from "../plugins/questionnaires/containers/QuestionnairesOverview";
import Surveys from "../plugins/questionnaires/containers/Surveys";
import SurveysOverview from "../plugins/questionnaires/containers/SurveysOverview";
import UserManagement from "./UserManagement";
import RoleManagement from "./RoleManagement";
import UserActions from "./UserActions";
import OrganizationManagement from "./OrganizationManagement";
// Unterseiten
import NoMatch from "./pages/NoMatch";
import LandingPageQuestionnaires from "../plugins/questionnaires/containers/pages/LandingPage";
import RegistrationQuestionnaires from "../plugins/questionnaires/containers/pages/Registration";
import LandingPageReports from "../plugins/reports/containers/pages/LandingPage";
import RegistrationReports from "../plugins/reports/containers/pages/Registration";
import DataProtection from "./pages/DataProtection";
import Imprint from "./pages/Imprint";
import Agb from "./pages/Agb";
import ExecutableSurveys from "../plugins/questionnaires/containers/pages/ExecutableSurveys";
import PricesQuestionnaires from "../plugins/questionnaires/containers/pages/Prices";
import SafetyAppsQuestionnaires from "../plugins/questionnaires/containers/pages/SafetyApps";
// Aktionen
import { fetchUser } from "../actions/Users";
import { getOrderableQuestionnaires } from "../plugins/questionnaires/actions/Questionnaires";

const mapStateToProps = ( state ) =>
{
	const params = {
		messages: state.messages,
		environment: state.environment,
		title: state.title,
		user: state.user,
		isFetching: state.isFetching
	};
	
	// Pluginparameter
	if ( Configuration.pluginName === "questionnaires" )
	{
		params[ "orderableQuestionnaires" ] = state.orderableQuestionnaires;
	}
	else if ( Configuration.pluginName === "reports" )
	{
	
	}
	
	return params;
};

const mapDispatchToProps = ( dispatch ) =>
{
	const params = {
		getConfigurations: () =>
		{
			dispatch( getConfigurations() );
		},
		fetchUser: () =>
		{
			dispatch( fetchUser() );
		}
	};
	
	// Pluginparameter
	if ( Configuration.pluginName === "questionnaires" )
	{
		params[ "getOrderableQuestionnaires" ] = () =>
		{
			dispatch( getOrderableQuestionnaires() );
		};
	}
	else if ( Configuration.pluginName === "reports" )
	{
	
	}
	
	return params;
};

class App extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			cookieBanner: !localStorage.getItem( "cookieBanner" ),
			device: "ontouchstart" in document.documentElement ? " mobile" : " desktop"
		};
		
		this.handleBanner = this.handleBanner.bind( this );
		
		// Google Analytics
		localStorage.setItem( "ga", "true" );
		
		// Einstellungen holen falls nicht im Storage
		if ( !localStorage.getItem( "gac" ) || !localStorage.getItem( "gvc" ) || !localStorage.getItem( "environment" ) )
		{
			this.props.getConfigurations();
		}
		else
		{
			sessionStorage.setItem( "gaInitialized", ReactGA.initialize( localStorage.getItem( "gac" ) ) );
			this.props.fetchUser();
		}
		
	} // function constructor(...)
	
	handleBanner()
	{
		this.setState( { cookieBanner: false } );
		localStorage.setItem( "cookieBanner", "false" );
		
	} // function handleBanner()
	
	render()
	{
		let title = this.props.title;
		let header = <NavHeader/>;
		
		switch ( Configuration.pluginName )
		{
			case "reports":
				header = <ReportsNavHeader/>;
				if ( typeof this.props.title === "string" )
				{
					title = <h1 className={"col s12 primary-color-text margin-top padding-top"}>
						{this.props.title}
					</h1>;
				}
				break;
			case "questionnaires":
			default:
				if ( typeof this.props.title === "string" )
				{
					title = <h1 className={"col s12 white-text"}>
						{this.props.title}
					</h1>;
				}
				break;
		}
		
		
		return [
			<BrowserRouter key="browserrouter">
				<div className={`App${this.state.device}`} role="application">
					
					{this.props.user && header}
					
					<div id={"title"} className={"title"}>
						<article>
							<section>{title}</section>
						</article>
					</div>
					
					<div id={"section"} className={"section"}>
						<Switch>
							
							{/* Startseite */}
							{
								Configuration.pluginName === "questionnaires"
									? <Route exact strict path="/" render={() => <LandingPageQuestionnaires orderableQuestionnaires={this.props.orderableQuestionnaires}/>}/>
									: Configuration.pluginName === "reports"
									? <Route exact strict path="/" render={() => <LandingPageReports/>}/>
									: null
							}
							
							{/* Rechtliches */}
							<Route exact strict path="/impressum" component={Imprint}/>
							<Route exact strict path="/datenschutz" component={DataProtection}/>
							<Route exact strict path="/agb" component={Agb}/>
							
							{
								// nur für Gäste
								this.props.user && Access.isPermitted( this.props.user, [ "guest_user_permissions" ] ) &&
								[
									/* Informationsseiten */
									Configuration.pluginName === "questionnaires" &&
									[
										<Route key={"/richtlinienrecherche"} exact strict path="/richtlinienrecherche"
										       render={props => <ExecutableSurveys orderableQuestionnaires={this.props.orderableQuestionnaires}/>}/>,
										<Route key={"/preise"} exact strict path="/preise"
										       render={props => <PricesQuestionnaires orderableQuestionnaires={this.props.orderableQuestionnaires}/>}/>,
										<Route key={"/safety-apps"} exact strict path="/safety-apps"
										       render={props => <SafetyAppsQuestionnaires orderableQuestionnaires={this.props.orderableQuestionnaires}/>}/>
									],
									
									/* Benutzeraktionen */
									<Route key={"/aktivierung"} exact strict path={"/aktivierung"} component={UserActions}/>,
									<Route key={"/passwort"} exact strict path={"/passwort"} component={UserActions}/>,
									<Route key={"/passwort-vergessen"} exact strict path={"/passwort-vergessen"} component={UserActions}/>,
									<Route key={"/passwort-zuruecksetzen"} exact strict path={"/passwort-zuruecksetzen"} component={UserActions}/>,
									
									Configuration.pluginName === "questionnaires" &&
									<Route key={translations.de_DE.routes.registration} exact strict path={translations.de_DE.routes.registration}
									       component={RegistrationQuestionnaires}/>,
									
									Configuration.pluginName === "reports" &&
									<Route key={translations.de_DE.routes.registration} exact strict path={translations.de_DE.routes.registration}
									       component={RegistrationReports}/>
								]
							}
							
							{
								// nur für angemeldete und aktive Benutzer, sonst auf 403 Umleiten
								this.props.user &&
								[
									<Route key={"/passwort-aendern"} exact strict path="/passwort-aendern"
									       render={props =>
										       <Access permissions={[ "change_user_password" ]} redirectTo={"/403"}>
											       <UserActions location={props.location} permissions={[ "change_user_password" ]}/>
										       </Access>}/>,
									<Route key={"/benutzerverwaltung"} exact strict path="/benutzerverwaltung"
									       render={props =>
										       <Access permissions={[ "get_users" ]} redirectTo={"/403"}>
											       <UserManagement location={props.location}/>
										       </Access>}/>,
									
									/* Berechtigungsverwaltung */
									<Route key={"/berechtigungsverwaltung"} exact strict path="/berechtigungsverwaltung"
									       render={props =>
										       <Access permissions={[ "get_roles", "get_permissions" ]} redirectTo={"/403"}>
											       <RoleManagement location={props.location}/>
										       </Access>}/>,
									
									/* Organisationsverwaltung */
									<Route key={"/organisationsverwaltung"} exact strict path="/organisationsverwaltung"
									       render={props =>
										       <Access permissions={[ "get_organizations", "get_faktura_organization", "get_faktura_organizations" ]} redirectTo={"/403"}>
											       <OrganizationManagement location={props.location}/>
										       </Access>}/>,
									
									/* Fragebogen */
									Configuration.pluginName === "questionnaires" &&
									[
										<Route key={translations.de_DE.routes.survey} exact strict path={translations.de_DE.routes.survey}
										       render={props =>
											       <Access permissions={[ "get_survey" ]} redirectTo={"/403"}>
												       <SurveysOverview location={props.location}/>
											       </Access>}/>,
										<Route key={translations.de_DE.routes.surveyTest} exact strict path={translations.de_DE.routes.surveyTest}
										       render={props =>
											       <Access permissions={[ "test_survey" ]} redirectTo={"/403"}>
												       <SurveysOverview location={props.location} test/>
											       </Access>}/>,
										<Route key={translations.de_DE.routes.surveys} exact strict path={translations.de_DE.routes.surveys}
										       render={props =>
											       <Access permissions={[ "get_surveys" ]} redirectTo={"/403"}>
												       <SurveysOverview location={props.location}/>
											       </Access>}/>,
										<Route key={`${translations.de_DE.routes.survey}/:id`} exact strict path={`${translations.de_DE.routes.survey}/:id`}
										       render={props =>
											       <Access permissions={[ "get_survey" ]} redirectTo={"/403"}>
												       <Surveys id={props.match.params.id}/>
											       </Access>}/>,
										<Route key={`${translations.de_DE.routes.surveyTest}/:id`} exact strict path={`${translations.de_DE.routes.surveyTest}/:id`}
										       render={props =>
											       <Access permissions={[ "test_survey" ]} redirectTo={"/403"}>
												       <Surveys id={props.match.params.id} survey={props}/>
											       </Access>}/>,
										<Route key={translations.de_DE.routes.questionnaires} exact strict path={translations.de_DE.routes.questionnaires}
										       render={props =>
											       <Access permissions={[ "get_questionnaires" ]} redirectTo={"/403"}>
												       <QuestionnairesOverview location={props.location}/>
											       </Access>}/>,
										<Route key={`${translations.de_DE.routes.questionnaire}`} exact strict
										       path={`${translations.de_DE.routes.questionnaire}`}
										       render={props =>
											       <Access permissions={[ "get_questionnaire" ]} redirectTo={"/403"}>
												       <Questionnaires location={props.location}/>
											       </Access>}/>,
										<Route key={`${translations.de_DE.routes.questionnaire}/:id`} exact strict
										       path={`${translations.de_DE.routes.questionnaire}/:id`}
										       render={props =>
											       <Access permissions={[ "get_questionnaire" ]} redirectTo={"/403"}>
												       <Questionnaires id={props.match.params.id}/>
											       </Access>}/>
									],
									
									/* Fehlerseiten */
									<Route key={"/401"} exact strict path="/401" component={props => <NoMatch errorCode={"401"}/>}/>,
									<Route key={"/402"} exact strict path="/402" component={props => <NoMatch errorCode={"402"}/>}/>,
									<Route key={"/403"} exact strict path="/403" component={props => <NoMatch errorCode={"403"}/>}/>,
									<Route key={"/500"} exact strict path="/500" component={props => <NoMatch errorCode={"500"}/>}/>,
									<Route key={"/no-match"} component={NoMatch}/>
								]
							}
						</Switch>
					</div>
					
					<footer className={`secondary-color white-text ${localStorage.getItem( "environment" )}`}>
						<article>
							<div className="col s12 tCenter">
								<NavLink to="//de.esch.design" target="_blank">made with <span className="red-text">❤</span> by esch.design</NavLink><br/>
								<NavLink to="/impressum">Impressum</NavLink> | <NavLink to="/datenschutz">Datenschutz</NavLink> | <NavLink to="/agb">AGB</NavLink>
							</div>
						</article>
						<div className="col s12 tCenter secondary-color">
							{
								this.state.cookieBanner &&
								<div className="cookie-banner">
									<span className="cookie-message">Diese Seite nutzt Cookies / Local Storage. Mit der Nutzung erklären Sie sich damit einverstanden, dass wir Cookies verwenden. <NavLink
										to={"/datenschutz"}><strong>{translations.de_DE.words.data_protection}</strong></NavLink>.</span>
									<button onClick={() => this.handleBanner()}>Fortfahren</button>
								</div>
							}
						</div>
					</footer>
				</div>
			
			</BrowserRouter>,
			<Messages key="messages"/>
		];
		
	} // function render()
	
} // class

App = connect(
	mapStateToProps,
	mapDispatchToProps
)( App );

export default App;